import { render, staticRenderFns } from "./CoinBalance.vue?vue&type=template&id=7dbbb432"
import script from "./CoinBalance.vue?vue&type=script&lang=js"
export * from "./CoinBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
